import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import { OnBlur } from 'react-final-form-listeners';
import { Form, Col, Card, Alert, Spinner, Modal, Row, Container, Button } from 'react-bootstrap';

//Api
import axios from '../../../apis/apicidtech';

//Components
import { campotexto } from '../campos/campos';

//Actions
import { pesquisa } from '../../../actions/login/login';

//Utils
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';
import { getUserLoginCred } from '../../../utils/eventosessioncred';

class DadosDeAcesso extends React.Component {

    state = {
        logado: false,
        showModal: false,
        emailverificado: ''
    }

    componentDidMount() {
        const cadastro = getUserLoginCred();
        this.setState({
            logado: (cadastro && cadastro.fisica && cadastro.fisica.idfisica ? true : false)
        });
        if (cadastro && cadastro.fisica && cadastro.fisica.idfisica) {
            this.handlePesquisaDominioEmail(cadastro.email, cadastro.fisica.juridica.idpais)
        }
    }

    handlePesquisaEmail = async () => {
        
        const value = this.props.form.getFieldState('email').value;
        const idpais = this.props.form.getFieldState('idpais').value;

        if (value !== '' && this.state.logado === false) {
            const response = await this.props.pesquisa({
                idpromotora: this.props.dadosevento.idpromotora,
                idevento: this.props.dadosevento.idevento,
                email: value
            });
            if (response.result === true) {
                this.setState({
                    emailverificado: value
                });
                this.props.form.change('email', '');
                this.handleShow();
            }
            await this.handlePesquisaDominioEmail(value, idpais);
        }
    }

    handlePesquisaDominioEmail = async (email, idpais) => {
        
        const str = email.split(".");
        const email_dominio = str[str.length - 1];
        if (email_dominio !== '' && parseInt(idpais) === 214) {
            await axios.get('endereco/pesquisa/paises', {
                headers: {
                    Accept: 'application/json'
                },
                params: {
                    dominio: email_dominio
                }
            }).then(response => {
                if (response.data.length) {
                    //this.props.handlePesquisaQuestionario({passo: [1,6]});
                    this.props.handlePesquisaQuestionario({ passo: [1, 3, 2, 6] });
                } else {
                    //this.props.handlePesquisaQuestionario({passo: [1,2]});
                    this.props.handlePesquisaQuestionario({ passo: [1, 3, 2, 6] });
                }
            })
        }
    }

    handleClose = () => {
        this.setState({
            showModal: false
        });
    }
    handleShow = () => {
        this.setState({
            showModal: true
        });
    }

    render() {
        const trads = this.props.trads;
        const lingua = this.props.lingua;

        return (
            <>
                <Card className='mb-3'>
                    <Card.Header><Card.Title>{trad(trads, 'ACESSO', lingua)}</Card.Title></Card.Header>
                    <Card.Body>
                        <Form.Row>
                            <Form.Group as={Col} md="4" controlId="email" style={this.props.styles['email'] ? this.props.styles['email'] : {}}>
                                <Field
                                    type='text'
                                    styles={this.props.styles}
                                    placeholder={trad(trads, 'TITLEEMAIL', lingua)}
                                    label={trad(trads, 'TITLEEMAIL', lingua)}
                                    name='email'
                                    component={campotexto}
                                    readOnly={this.state.logado}
                                />
                                <OnBlur name="email">
                                    {(value) => {
                                        this.handlePesquisaEmail(value);
                                    }}
                                </OnBlur>
                                {this.props.pesquisaemail && this.props.pesquisaemail.result === true ?
                                    <Alert variant="warning">{trad(trads, 'INFOEMAILJAADD', lingua)}</Alert>

                                    :
                                    null
                                }                                
                            </Form.Group>
                            {this.state.logado === false ?
                                <Form.Group as={Col} md="4" controlId="confemail" style={this.props.styles['confemail'] ? this.props.styles['confemail'] : {}}>
                                    <Field type='text'
                                        styles={this.props.styles}
                                        placeholder={trad(trads, 'CONF_EMAIL', lingua)}
                                        label={trad(trads, 'CONF_EMAIL', lingua)} name='confemail' component={campotexto} />
                                </Form.Group>
                                :
                                null
                            }
                        </Form.Row>
                        <Form.Row>
                            {this.state.logado === false ?
                                <>
                                    <Form.Group as={Col} md="4" controlId="senha" style={this.props.styles['senha'] ? this.props.styles['senha'] : {}}>
                                        <Field type='password'
                                            styles={this.props.styles}
                                            placeholder={trad(trads, 'TITLESENHA', lingua)}
                                            label={trad(trads, 'TITLESENHA', lingua)} name='senha' component={campotexto} />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="confsenha" style={this.props.styles['confsenha'] ? this.props.styles['confsenha'] : {}}>
                                        <Field type='password'
                                            styles={this.props.styles}
                                            placeholder={trad(trads, 'TITLECONFSENHA', lingua)}
                                            label={trad(trads, 'TITLECONFSENHA', lingua)} name='confsenha' component={campotexto} />
                                    </Form.Group>
                                </>
                                :
                                null
                            }
                        </Form.Row>
                    </Card.Body>
                </Card>
                <Modal show={this.state.showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>E-mail {<strong>{this.state.emailverificado}</strong>} já credenciado</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col>
                                    <p>
                                        Ops! Encontrei um cadastro com este e-mail!
                                    </p>
                                    <p>
                                        Caso esteja tentando acessar seus dados,
                                        retorne para a página de login.
                                    </p>
                                    <p>
                                        Caso seja um novo cadastro, informe um e-mail diferente.
                                    </p>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cadastrar outro e-mail
                        </Button>
                        <Button variant="primary" onClick={() => this.props.history.push('login')}>
                            Login
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        pesquisaemail: state.pesquisaLoginReducer,
        pendingTasks: state.pendingTasks
    }
}

export default connect(mapStateToProps, { pesquisa })(DadosDeAcesso);